import _ from 'lodash';
import Service from './abstract';
import usersService from './users';

const defaultPlatform = 8;

class Login extends Service {
    constructor () {
        super('auth');
    }

    login (data) {
        return this.post({
            url: `${this.baseUrlLogin}/login?with=${usersService.fullWith}`,
            data: _.defaultsDeep({}, data, { idPlatform: defaultPlatform }),
        })
            .then(res => usersService.normalize(res));
    }

    recover (id) {
        return this.post({
            url: `${this.baseUrlLogin}/recover`,
            data: {
                idUser: id
            }
        });
    }

    register (data) {
        const options = {
            url: `${this.baseUrlLogin}/register`,
            data
        };

        return this.post(options)
            .then(res => {
                return this.post({
                    url: `${this.baseUrlLogin}/verify`,
                    data: {
                        idPlatform: defaultPlatform,
                        email: data.person.emails[0].email,
                        metadata: {
                            user: {
                                id: res.id,
                                fullname: data.fullname
                            },
                            subject: 'Cuotas ya | Verificación de cuenta',
                            url: `https://${window.location.host}/auth/verify`
                        }
                    }
                });
            });
    }

    validate (data) {
        return this.post({
            url: `${this.baseUrlLogin}/validate`,
            data
        });
    }

    validateForgot (data) {
        return this.post({
            url: `${this.baseUrlLogin}/password/forgot/validate`,
            data
        });
    }

    change (data) {
        return this.post({
            url: `${this.baseUrlLogin}/password/recover`,
            data
        });
    }

    changeEmail (body) {
        return this.post({
            url: `${this.baseUrlLogin}/verify`,
            body
        });
    }

    changePassword (body) {
        return this.post({
            url: `${this.baseUrlLogin}/password/change`,
            body
        });
    }

    forgot (data) {
        return this.post({
            url: `${this.baseUrlLogin}/password/forgot`,
            data
        });
    }
}

export default new Login();
